// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-save-notice-modal {
  max-width: 420px;
}

.download-save-notice-modal__body {
  padding: 1.25rem 1.5rem 1.35rem;
}

/* Icon and title are styled here rather than borrowed from
   .dialog-popup-icon / .dialog-popup-title so this modal does not depend on
   the shared section-dialog header, which also carries a placeholder
   subtitle that does not belong in this copy. */
.download-save-notice-modal__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-bottom: 0.75rem;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  color: #ffffff;
  font-size: var(--ui-font-title-lg);
  flex-shrink: 0;
}

.download-save-notice-modal__title {
  margin: 0;
  color: #1e293b;
  font-size: var(--ui-text-page-title);
  font-weight: 600;
  line-height: 1.4;
}

.download-save-notice-modal__message {
  margin: 0.35rem 0 1rem;
  font-size: 13px;
  line-height: 1.5;
  color: #4a4a4a;
}

.download-save-notice-modal__confirm {
  width: 100%;
  border: none;
  border-radius: 10px;
  padding: 9px 0;
  background: var(--primary-color, #0069a5);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.download-save-notice-modal__confirm:hover {
  filter: brightness(1.08);
}`, "",{"version":3,"sources":["webpack://./src/components/ui/DownloadSaveNoticeModal.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;gDAGgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,iFAAiF;EACjF,cAAc;EACd,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,yCAAyC;EACzC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".download-save-notice-modal {\n  max-width: 420px;\n}\n\n.download-save-notice-modal__body {\n  padding: 1.25rem 1.5rem 1.35rem;\n}\n\n/* Icon and title are styled here rather than borrowed from\n   .dialog-popup-icon / .dialog-popup-title so this modal does not depend on\n   the shared section-dialog header, which also carries a placeholder\n   subtitle that does not belong in this copy. */\n.download-save-notice-modal__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  margin-bottom: 0.75rem;\n  border-radius: 12px;\n  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));\n  color: #ffffff;\n  font-size: var(--ui-font-title-lg);\n  flex-shrink: 0;\n}\n\n.download-save-notice-modal__title {\n  margin: 0;\n  color: #1e293b;\n  font-size: var(--ui-text-page-title);\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.download-save-notice-modal__message {\n  margin: 0.35rem 0 1rem;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #4a4a4a;\n}\n\n.download-save-notice-modal__confirm {\n  width: 100%;\n  border: none;\n  border-radius: 10px;\n  padding: 9px 0;\n  background: var(--primary-color, #0069a5);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: filter 0.15s ease;\n}\n\n.download-save-notice-modal__confirm:hover {\n  filter: brightness(1.08);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
